<template>
  <div :data-testid="getTestId('admin-panel-planning-page')">
    <PanelPlanningPage :data-testid="getTestId('admin-panel-planning-page')" />
  </div>
</template>

<script>
import Vue from 'vue';
import { getTestId } from '@/utils/testUtils';
import {
  appPerfMark,
  appPerfMeasure,
  appPerfSinceMyProfile,
  appPerfScheduleFirstPaint
} from '@/utils/appBootstrapPerfLog.js';

const PanelPlanning = Vue.extend({
  name: 'PanelPlanning',
  components: {
    PanelPlanningPage: () => {
      appPerfMark('PanelPlanning:chunkLoad:start');
      return import('../../features/panel-planning/components/PanelPlanningPage').then((mod) => {
        appPerfMeasure('PanelPlanning:chunkLoad', 'PanelPlanning:chunkLoad:start');
        appPerfSinceMyProfile('PanelPlanning:chunkLoaded');
        return mod;
      });
    }
  },
  methods: {
    /**
     * 테스트 ID 생성
     * @param {string} testId - 테스트 ID
     * @returns {string} 생성된 테스트 ID
     */
    getTestId(testId) {
      return getTestId(testId);
    }
  },
  mounted() {
    appPerfMark('PanelPlanning:wrapper:mounted');
    appPerfSinceMyProfile('PanelPlanning:wrapper:mounted');
    appPerfScheduleFirstPaint('PanelPlanning:wrapper');
  }
});

export default PanelPlanning;
</script>

<style scoped>
/* 필요한 스타일이 있다면 여기에 추가 */
</style>
